import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { NewsItem } from '../models/news-widget/news-item-model';

@Injectable({
  providedIn: 'root'
})
export class NewsWidgetService {
  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getStudentNews(classId: string): Observable<NewsItem[]> {
    const url = this.urlService.buildServerApiUrl('news/getStudentNews', classId);
    return this.httpClient.get<NewsItem[]>(url);
  }

  public getTeacherNews(): Observable<NewsItem[]> {
    const url = this.urlService.buildServerApiUrl('news/getTeacherNews');
    return this.httpClient.get<NewsItem[]>(url);
  }

  public markAsSeen(id: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('news/markAsSeen');
    return this.httpClient.post<void>(url, { id });
  }

  public getTeacherEvents(): Observable<NewsItem[]> {
    throw new Error('Method not implemented.');
  }
}
